module.exports = __webpack_public_path__ + "img/it.66c51658.svg";